import { useCallback } from 'react';
import { useNavigate, type NavigateOptions } from 'react-router';

import { useOptionalDataSource } from '@/features/data/DataSourceContext';

import { inView, withBase } from './paths';
import { useCurrentView } from './useCurrentView';

/**
 * `navigate('/deepdive-ai/abc')` with the current tree's base applied — and,
 * from an executive page, to the executive view's copy of the module (`inView`).
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const basePath = useOptionalDataSource()?.basePath ?? '';
  const view = useCurrentView();
  return useCallback(
    (to: string, options?: NavigateOptions) =>
      navigate(withBase(basePath, inView(to, view)), options),
    [navigate, basePath, view],
  );
}
